import './App.css';
import './index.css';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Home from './pages/Home.js';
import EmbeddedHome from './pages/EmbeddedHome';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import ConfigPage from './pages/ConfigPage';
import Subscribe from './pages/Subscribe';
import PrivateEvents from './pages/PrivateEvents';
import Community from './pages/Community.js';
import HomeOld from './pages/HomeOld.js';
import NotFound from './pages/NotFound.js';
import LandscapeWarning from './components/LandscapeWarning';
import config from './config';
import { useEffect, useState } from 'react';

function AppContent() {
  const location = useLocation();
  const isEmbedded = location.pathname === '/embed';
  const isHomePage = location.pathname === '/';
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  
  useEffect(() => {
    // Check for app updates
    const currentVersion = localStorage.getItem('app_version');
    const currentBuildTime = localStorage.getItem('app_build_time');
    
    if (currentVersion !== config.appVersion) {
      // Clear cache and reload
      localStorage.clear();
      localStorage.setItem('app_version', config.appVersion);
      window.location.reload(true);
    }
  }, []);

  // If we're embedded and not on the /embed route, render the embedded version
  if (isEmbedded && !location.pathname.startsWith('/embed')) {
    return <EmbeddedHome />;
  }

  return (
    
    <div className={`App min-h-screen flex flex-col ${
      !isEmbedded ? "xl:bg-[url('atltechevents.png')] bg-[url('atltechevents-bg.png')] bg-fixed xl:bg-cover bg-center bg-no-repeat" : ""
    } h-screen`}>

        <link 
            rel="stylesheet" 
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" 
            integrity="sha512-9usAa10IRO0HhonpyAIVpjrylPvoDwiPUiKdWk5t3PyolY1cOd4DSE0Ga+ri4AuTroPR5aQvXU9xC6qOPnzFeg==" 
            crossOrigin="anonymous" 
            referrerPolicy="no-referrer" 
          />


      {!isEmbedded && (
        <>
          <a 
            href="#main-content" 
            className="sr-only focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:z-50 focus:p-4 focus:bg-white focus:text-black focus:outline-none"
          >
            Skip to main content
          </a>

          <LandscapeWarning />

        <div className="block md:hidden flex items-center justify-between shadow-sm h-10 bg-white mb-2 pl-2 pr-2  ">
          <div className="flex items-center text-center">
            <div className="flex items-center"></div>
            <Link to="/" className="flex items-center">
              <img src="favicon-32x32.png" alt="ATL Tech Events" className="h-8 w-8 object-contain" />
              <span className="flex text-center w-full ml-2 font-bold text-lg">ATL Tech Events</span>
            </Link>
            
          </div>
          <button 
            onClick={() => setShowMobileMenu(!showMobileMenu)} 
            className="mt-0 rounded-lg hover:bg-gray-100 bg-gray-200 h-8 w-8"
            aria-label="Toggle navigation menu"
            aria-expanded={showMobileMenu}
          >
            <i className={`fas fa-${showMobileMenu ? 'times' : 'bars'} text-xl`}></i>
          </button>
        </div>
        {showMobileMenu && (
          <div className="block md:hidden bg-white shadow-lg">
            <nav className="flex flex-col p-4" role="navigation" aria-label="Mobile navigation">
              <Link to="/" className="py-2 hover:text-blue-700" onClick={() => setShowMobileMenu(false)}>Home</Link>
              <Link to="/about" className="py-2 hover:text-blue-700" onClick={() => setShowMobileMenu(false)}>About</Link>
              <Link to="/community" className="py-2 hover:text-blue-700" onClick={() => setShowMobileMenu(false)}>Community</Link>
              <Link to="/subscribe" className="py-2 hover:text-blue-700" onClick={() => setShowMobileMenu(false)}>Subscribe</Link>
              <Link to="/privacy" className="py-2 hover:text-blue-700">Privacy</Link>
              <Link to="/terms" className="py-2 hover:text-blue-700">Terms</Link>
              <hr className="my-2" />
              <span className="">Brought to you by <a target="_blank" rel="noopener noreferrer" href="https://www.mirability.com">Mirability<sup>SM</sup></a></span>
               <a target="_blank" rel="noopener noreferrer" href="https://www.mirability.com"> <img src="logo-black-transparent-300.png" alt="Mirability" className="max-h-10 object-contain mx-auto" /></a>
              <div className="text-xs md:text-sm border-t border-gray-200 pt-2 mt-2">
            <p>ATL Tech Events<sup>SM</sup> (atltech.events) and Event Horizon Media<sup>SM</sup> are the Service Marks of Mirability, LLC<sup>SM</sup>.</p>
            <p>Copyright 2025 Mirability, LLC. All Rights Reserved.</p>
            </div>
            </nav>
          </div>
        )}

        </>
      )}

      {!isEmbedded && !isHomePage && (
        <>
         <div id="top-nav-container" className="hidden md:block">
          
          <nav className="text-black p-4" role="navigation" aria-label="Main navigation">
            <div className="container mx-auto flex flex-wrap justify-between items-center">
              <Link to="/" className="text-xl invisible" aria-hidden="true" aria-label="Home">ATL Tech Events</Link>
              <div className="flex space-x-4">
                <Link to="/" className="hover:text-blue-700" aria-current="page">Home</Link>
                <Link to="/about" className="hover:text-blue-700">About</Link>
                <Link to="/community" className="hover:text-blue-700">Community</Link>
                <Link to="/subscribe" className="hover:text-blue-700">Subscribe</Link>
              </div>
            </div>
          </nav>

          <div className="flex justify-center w-full">
          <div  className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">  

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4" >
          <div className="grid gap-4">
            <div className="flex flex-row items-center justify-center space-x-4">
              <img src="atl-tech-events-logo-transparent.png" alt="ATL Tech Events" className="block xl:hidden max-h-24 object-contain" />
              <img src="logo-black-transparent-300.png" alt="Mirability" className="block md:hidden xl:hidden max-h-10 object-contain" />
            </div>
          </div>

          <div className="grid grid-cols-3 gap-2 sm:gap-4 justify-self-end ml-auto text-right">
            <div className="hidden md:block w-full col-span-3 text-center mb-4">
              <a target="_blank" rel="noopener noreferrer" href="https://www.mirability.com">
                <img src="logo-black-transparent-300.png" alt="Mirability" className="w-full max-h-24 object-contain mx-auto mb-2" />
              </a>
              <span>Brought to you by <a target="_blank" rel="noopener noreferrer" href="https://www.mirability.com">Mirability<sup>SM</sup></a></span>
            </div>

            <div className="col-span-3 flex justify-end gap-2 sm:gap-4 mb-2">

            <div className="text-sm text-gray-500 font-bold bg-yellow-600 text-white max-h-8 rounded-full px-2 py-1 sm:mb-0">
            BETA VERSION
          </div>

            </div>
          </div>

          </div>
              
            </div>
          </div>
        </div>

        </>
      )}

<div id="scroll-here"></div>

      <main id="main-content" className="flex-grow" role="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/embed" element={<EmbeddedHome />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/config" element={<ConfigPage />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/private-events" element={<PrivateEvents />} />
          <Route path="/community" element={<Community />} />
          <Route path="/old" element={<HomeOld />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>


      {!isEmbedded && !isHomePage && (
        <footer className="hidden md:fixed bg-slate-300 p-2 md:p-4 text-center bottom-0 left-0 right-0 z-10" role="contentinfo">
          <div className="container mx-auto">
            
            <nav className="mb-2 md:mb-4" role="navigation" aria-label="Footer navigation">
              <div className="flex justify-center space-x-4 text-sm md:text-base">
                <Link to="/privacy" className="hover:text-blue-700">Privacy</Link>
                <Link to="/terms" className="hover:text-blue-700">Terms</Link>
              </div>
            </nav>
            <div className="text-xs md:text-sm">
            <p>ATL Tech Events<sup>SM</sup> (atltech.events) and Event Horizon Media<sup>SM</sup> are the Service Marks of Mirability, LLC<sup>SM</sup>.</p>
            <p>Copyright 2025 Mirability, LLC. All Rights Reserved.</p>
            </div>
          </div>
        </footer>
      )}
      {!isEmbedded && !isHomePage && (
        <footer className="bg-slate-300 p-2 md:p-4 text-center bottom-0 left-0 right-0 z-10" role="contentinfo">
        <div className="container mx-auto">
          
          <nav className="mb-2 md:mb-4" role="navigation" aria-label="Footer navigation">
            <div className="flex justify-center space-x-4 text-sm md:text-base">
              <Link to="/privacy" className="hover:text-blue-700">Privacy</Link>
              <Link to="/terms" className="hover:text-blue-700">Terms</Link>
            </div>
          </nav>
          <div className="text-xs md:text-sm">
          <p>ATL Tech Events<sup>SM</sup> (atltech.events) and Event Horizon Media<sup>SM</sup> are the Service Marks of Mirability, LLC<sup>SM</sup>.</p>
          <p>Copyright 2025 Mirability, LLC. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
